<template lang="pug">
  include /mixins
  +b.modal-wrapper
    +b.t-result-form
      +e.aside
        +e.title {{ _("Результаты до и после") }}
        +e.hint
          +b.ds-caption--size_xs.--size_md-xl.--appearance_center-till-md.--medium.P {{ hintText }}
      +e.content
        ui-loader(v-if='isLoad')
        +e.steps
          +b.t-steps
            +e.item(
              v-for="index in 3"
              :class="{ 'is-highlighted': currentStepIndex >= index }"
            )
              +e.SPAN.count {{ index }}
        +e.content
          result-create-step-first(
            v-if="currentStepIndex === 1"
            :form="form"
            :choices="choices"
            :orientation-map="$options.ORIENTATION"
            :is-equipment="info.is_equipment"
            @upload="setKeys"
            @clear="clearImages"
          )
          result-create-step-second(
            v-else-if="currentStepIndex === 2"
            :form="form"
            :is-equipment="info.is_equipment"
            @upload="resetNonFieldErrors"
          )
          +b.VALIDATION-OBSERVER(
            v-else-if="currentStepIndex === 3"
            ref="validator",
            v-slot="{ valid }",
            tag="form",
          )
            result-create-step-third(
              :form="form"
            )
          .relative(v-if="non_field_errors")
            +b.error-label.LABEL {{ non_field_errors[0] }}
        +e.footer
          +b.g-row.--appearance_spaced(
            :class="currentStepIndex === 1 ? 'g-row--justify_end' : 'g-row--justify_between'"
          )
            +b.g-cell(v-if="currentStepIndex !== 1")
              +b.BUTTON.tt-button.--bordered_main(
                @click.prevent="prevStep"
              )
                +e.title.SPAN {{ _("Предыдущий шаг") }}
            +b.g-cell(v-if="currentStepIndex !== 3")
              +b.BUTTON.tt-button(
                @click.prevent="nextStep"
              )
                +e.title.SPAN {{ _("Следующий шаг") }}
            +b.g-cell(v-else)
              +b.BUTTON.tt-button(
                @click.prevent="nextStep"
                :disabled="isLoad"
              )
                +e.title.SPAN {{ _("Подтвердить и отправить") }}
</template>

<script>
import {
  ResultCreate,
  EquipmentResultCreate,
} from '@api/store.service'
import { AnswerMessage } from '@utils/submit'
import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin'

import ResultCreateStepFirst from './StepFirst'
import ResultCreateStepSecond from './StepSecond'
import ResultCreateStepThird from './StepThird'

const ORIENTATION = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
}

export default {
  name: 'CreateResultView',

  ResultCreate,
  EquipmentResultCreate,

  ORIENTATION,

  components: {
    'result-create-step-first': ResultCreateStepFirst,
    'result-create-step-second': ResultCreateStepSecond,
    'result-create-step-third': ResultCreateStepThird,
  },

  mixins: [FormMixin],

  props: ['info'],

  data() {
    return {
      choices: {
        result_layout_type: [
          { label: this._('Вертикальное фото'), value: ORIENTATION.VERTICAL },
          { label: this._('Горизонтальное фото'), value: ORIENTATION.HORIZONTAL },
        ],
      },
      currentStepIndex: 1,
      hintText: this._('Пожалуйста, обратите внимание: загружая фотографии, вы подтверждаете, что ознакомились с Пользовательским Соглашением и у вас есть все необходимые разрешения на использование этих фотографий. Вы также подтверждаете, что права третьих лиц не нарушены.'),
      form: {
        result_layout_type: ORIENTATION.VERTICAL,
        patient_consent_obj: null,
        procedure_description: '',
        doctor_last_name: '',
        doctor_first_name: '',
        localFiles: {},
      },
      images: new Map(),
      non_field_errors: '',
    }
  },

  computed: {
    imagesKey() {
      return this.info.is_equipment ? 'equipment_result_images' : 'product_result_images'
    },
  },

  created() {
    this.form[this.imagesKey] = {}
  },

  methods: {
    async nextStep() {
      if (1 === this.currentStepIndex) {
        if (2 > Object.values(this.form[this.imagesKey]).length) {
          this.non_field_errors = [this._('Загрузите, пожалуйста, фото до и после процедуры')]

          return
        }

        this.currentStepIndex += 1
      } else if (2 === this.currentStepIndex) {
        if (!this.form.patient_consent_obj) {
          this.non_field_errors = [this._('Загрузите, пожалуйста, согласие пациента')]

          return
        }

        this.currentStepIndex += 1
      } else {
        const valid = await this.$refs.validator.validate()

        if (!valid) return

        this.submit(valid, this.form)
      }
    },

    prevStep() {
      this.currentStepIndex -= 1
    },

    setKeys({ val, name }) {
      this.form[this.imagesKey][name] = val

      this.resetNonFieldErrors()
    },

    resetNonFieldErrors() {
      this.non_field_errors = ''
    },

    clearImages() {
      this.form[this.imagesKey] = {}

      this.form.localFiles = {}
    },

    send() {
      const formdata = JSON.parse(JSON.stringify(this.form))

      if (this.info.is_equipment) {
        formdata.equipment = this.info.id
      } else {
        formdata.product = this.info.id
      }

      formdata[this.imagesKey] = Object.values(formdata[this.imagesKey])

      delete formdata.localFiles

      const resource = this.info.is_equipment ? EquipmentResultCreate : ResultCreate

      return resource.execute({}, formdata).then(res => {
        AnswerMessage(res.data, this)

        this.$emit('close')
      })
    },

    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)

      this.$refs.validator.setErrors(parsed)
    },
  },
}
</script>
